import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './_guards';
import { LayoutRegisterComponent } from './pages/register/register.component';
import {RecoveryComponent} from './pages/recovery/recovery.component'
import { KtidentityResetPasswordComponent } from './pages/ktidentity-reset-password/ktidentity-reset-password.component';
import { KtidentityLinkComponent } from './pages/ktidentity-link/ktidentity-link.component';
// import {TermsComponent} from './terms/terms.component';
import { DownloadComponent } from './_shared/download';

import { LoginComponent } from './layout/login/login.component';
import { AdminComponent } from './layout/admin/admin.component';
import { FilterDocumentComponent } from './pages/documents/filter-document/filter-document.component'
import { SocketTestComponent } from './pages/socket-test/socket-test.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: AdminComponent,
    children: [
      { path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      { path: 'home',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'documentos',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule)
      },
      {
        path: 'revisao',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/revisao/revisao.module').then(m => m.RevisaoModule)
      },
      {
        path: 'revisao-classificacao',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/revisao-classificacao/revisao-classificacao.module').then(m => m.RevisaoClassificacaoModule)
      },
      {
        path: 'revisao-documentos-nao-contratados',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/revisao-documentos-nao-contratados/revisao-documentos-nao-contratados.module').then(m => m.RevisaoDocumentosNaoContratadosModule)
      },
      {
        path: 'revisao-diagramacao',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/revisao-diagramacao/revisao-diagramacao.module').then(m => m.RevisaoModule)
      },
      {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
      },
      { 
        path: 'processamentos/:type',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/processamentos/processamentos.module').then(m => m.ProcessamentosModule)
      },
      {
        path: 'upload',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/upload/upload.module').then(m => m.UploadModule)
        // component: UploadComponent
      },
      {
        path: 'socket-test',
        component: SocketTestComponent
      },
      {
        path: 'video',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/video-player/video-player.module').then(m => m.VideoPlayerModule)
      },
      {
        path: 'not-found',
        component: NotFoundComponent
      },
      {
        path: 'forbidden',
        component: ForbiddenComponent
      }
    ],
    data: {
      'skin': 'skin-black',
      // USE THIS IS YOU WANT TO HIDE SOME TEMPLATE PART
      'boxed_style': false,
      'display_tasks': true,
      'display_user': true,
      'display_messages': true,
      'display_notifications': true,
      'display_menu_user': false,
      'display_menu_search': true,
      header_components: []
    }
  },
  // not logged routes
  {
    path: 'loginatvos',
    component: LoginComponent,
    data: [{
      'skin': 'skin-blue'
    }]
  },
  {
    path: 'loginallianz',
    component: LoginComponent,
    data: [{
      'skin': 'skin-blue'
    }]
  },
  {
    path: 'logintokio',
    component: LoginComponent,
    data: [{
      'skin': 'skin-blue'
    }]
  },
  {
    path: 'logindocsia',
    component: LoginComponent,
    data: [{
      'skin': 'skin-blue'
    }]
  },
  {
    path: 'login',
    component: LoginComponent,
    data: [{
      'skin': 'skin-blue'
    }]
  },

  // not logged routes
  
  {
    path: 'pages/recovery',
    data: [{
      'skin': 'skin-blue'
    }],
    component: RecoveryComponent
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent
  },
  // link do e-mail de redefinição do KTIdentity (o hash #/recuperar-senha/... é reescrito em main.ts)
  {
    path: 'recuperar-senha/:code/:token',
    component: KtidentityResetPasswordComponent
  },
  // link do e-mail de confirmação do vínculo da conta do Cognito com o KTIdentity
  {
    path: 'vincular-identity/:token',
    component: KtidentityLinkComponent
  },
  { path: '**', redirectTo: 'not-found' }
  
];

export { routes };

@NgModule({

  imports: [
    RouterModule.forRoot(routes)
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
